/* IBM Confidential‌ - OCO Source Materials‌ - (C) COPYRIGHT IBM CORP. 2020-2022 - The source code for this program is not published or otherwise‌ divested of its trade secrets, irrespective of what has been‌ deposited with the U.S. Copyright Office. */

import React from "react";
import {NavUrlHandler} from "../handlers/NavUrlHandler";
import {NavConfig} from "../utils";

const SITE_MAP_ID = '-1001';
const LEVEL_ONE = true;
const NOT_LEVEL_ONE = false;
const MENU_HREF_ID_PREFIX = 'tri-menu-href-';
const PROJECT_MENU_HREF_ID_PREFIX = 'tri-proj-menu-href-';

export class HierarchyListItemHandler {

    constructor() {
        this.listItemUrls = {};
        this.listItemsById = {};
        this.listItemIdsByName = {};
        this.listItemIds = [];
        this.childrenListItemIdsByTopParentId = {};
        this.isProjectSubMenu = false;
        this.siteMapMenuItems = [];
        this.projectContainerHandle = null;
    }

    handleFromProjectSubMenu(listItems, menuItems, projectContainerHandle) {
        this.siteMapMenuItems = [];
        this.listItemIds = [];
        this.isProjectSubMenu = true;
        this.projectContainerHandle = projectContainerHandle;
        this.handle(listItems, menuItems, LEVEL_ONE);
    }

    handleFromMain(menuItems) {
        this.siteMapMenuItems = [];
        this.listItemIds = [];
        this.handle([], menuItems, LEVEL_ONE);
    }

    handle(listItems, menuItems, isLevelOne, topParentMenuId, parentId, ascendingParentIds) {
        //First handle ascending parent ids
        let ascendingParentIdsClone = [];
        if(parentId) {
            //Clone and put most recent parent id in from of array to make ascending order.
            ascendingParentIdsClone = [...ascendingParentIds];
            ascendingParentIdsClone.unshift(parentId);
        }

        //Iterate through menu items
        for (var i = 0; i < menuItems.length; i++) {
            if (menuItems[i].metaData) {
                let listItem = {
                    content: {
                      value: menuItems[i].metaData.label
                    },
                    id: menuItems[i].id,
                    name: menuItems[i].name,
                    isNavPage: menuItems[i].isNavPage,
                    isOpenInNewWindow: menuItems[i].isOpenInNewWindow,
                    url: menuItems[i].metaData.url,
                    portalName: menuItems[i].metaData.portalName,
                    isSelectable: true,
                    ascendingParentIds: ascendingParentIdsClone,
                    label: menuItems[i].metaData.label
                }
                this.listItemUrls[listItem.id] = menuItems[i].metaData.url;
                this.listItemsById[listItem.id] = listItem;
                this.listItemIdsByName[listItem.name] = listItem.id;

                //Exclude sitemap unless we are on the project sub-menu
                if (listItem.id === SITE_MAP_ID && !this.isProjectSubMenu) {
                    continue;
                }

                //Track top parent menu id if not on level 1.
                if (!isLevelOne) {
                    listItem.topParentMenuId = topParentMenuId;

                    //Populate child into top parent array.
                    this.childrenListItemIdsByTopParentId[topParentMenuId].push(listItem.id);
                } else {
                    //Start building children array, and make first entry the top parent.
                    this.childrenListItemIdsByTopParentId[listItem.id] = [listItem.id];
                }
            
                //Iterate through children
                if (menuItems[i].childContent) {
                    //Handle top parent id if level 1.
                    if (isLevelOne) {
                        topParentMenuId = listItem.id;
                    }
                    listItem.isCategory = true;
                    let childrenListItems = [];
                    this.handle(childrenListItems, menuItems[i].childContent, NOT_LEVEL_ONE, 
                        topParentMenuId, listItem.id, listItem.ascendingParentIds);

                    listItem.children = childrenListItems;
                } else {
                    listItem.isCategory = false;
                }

                //Handle tag id if from project menu.
                //This tag is needed to assist with active vertical bar on project sub menu.
                if (this.isProjectSubMenu) {
                    this.projectContainerHandle.handleProjectSubMenuItemTagId(listItem);
                }

                //Handle hrefContent tag. This is needed for browser right click open in new window/tab functionality.
                listItem.hrefId = this._generateHrefId(listItem);
                this._handleHrefContentTag(listItem);

                //Ignore sysSuiteCatalog in project menu.
                if (listItem.name !== 'sysSuiteCatalog') {
                    //Push to array of all list items.
                    listItems.push(listItem);
                }
                
                //Push to array of all list item ids.
                if (!this.listItemIds.includes(listItem.id)) {
                    this.listItemIds.push(listItem.id);
                }

                 //Handle sitemap
                 if (isLevelOne && listItem.id !== SITE_MAP_ID) {
                    this.siteMapMenuItems.push(listItem);
                }
            }
        } 
    }

    _generateHrefId(menuItem) {
      return this.isProjectSubMenu ? (PROJECT_MENU_HREF_ID_PREFIX + menuItem.id): MENU_HREF_ID_PREFIX + menuItem.id;
    }

    _handleHrefContentTag(menuItem) {
      if (!menuItem.content.tags) {
        menuItem.content.tags = [];
      }

      let projectId = this.isProjectSubMenu ? 
          this.projectContainerHandle.state.currentProjectId: NavUrlHandler.COMPANY_LEVEL_PROJECT_ID;

      let navUrlHandler = new NavUrlHandler(menuItem, projectId);
      let menuItemUrl = NavConfig.CONTEXT_URL + menuItem.url;
      menuItemUrl = navUrlHandler.handleHistoryHash(menuItemUrl);
      menuItemUrl = menuItemUrl +
             (this.isProjectSubMenu ?
                navUrlHandler.handleProjectContextUrl(): "");
      menuItem.content.tags.push(<a id={menuItem.hrefId} className="triSubMenuListItem" href={menuItemUrl}></a>);
    }

    handleValidMenuItem(menuId) {
        let menuItem = this.getListItemById(menuId);
        if (menuItem == null) {
            menuId = this.getListItemIdByName("");
            menuItem = this.getListItemById(menuId);
        }
        return menuItem;
    }

    getListItemUrls() {
        return this.listItemUrls;
    }

    getListItemById(id) {
        return this.listItemsById[id];
    }

    getListItemIdByName(name) {
        return this.listItemIdsByName[name];
    }

    getListItemIds() {
        return this.listItemIds;
    }

    getSiteMapMenuItems() {
        return this.siteMapMenuItems;
    }

    getChildrenListItemIdsByTopParentId(topParentId) {
        return this.childrenListItemIdsByTopParentId[topParentId];
    }
}